export default {
  notepad: {
    pinned: "Angeheftet",
    unpinned: "Nicht angeheftet",
    all: "Alle Notizen",
    pinned_success: "Notiz erfolgreich angeheftet!",
    unpinned_success: "Notiz erfolgreich abgeheftet!",
    profiles: "Profile",
  },
};
